// 2. Жилая - аренда - комната
export default {
  address: [
    'user-input',
    'map',
    'underground',
  ],
  'about-object': [
    'common/cadastral-number',
    'rooms-for-sale-count',
    'room-area',
    'all-rooms-area',
    'floor',
    'plain-rooms-count',
    'urban-total-area-room',
    'kitchen-area',
    'visual-divider',
    'loggias-count',
    'balconies-count',
    'visual-divider',
    'separate-wcs-count',
    'combined-wcs-count',
    'visual-divider',
    'repair-type',
    'has-phone',
  ],
  'about-building': [
    'name-and-year',
    'material-type-and-series',
    'ceiling-height',
    'passenger-lifts',
    'cargo-lifts',
    'has-ramp',
    'in-house',
    'parking',
  ],
  'price-and-deal-terms': [
    'price',
    'sale-type',
    'agent-bonus',
  ],
};
